export const TOP_SECTION_TRADER_INFORMATION_TEST_ID = "trader-information";
export const TOP_SECTION_TRADER_NAME_AND_LAST_LOGIN_TEST_ID = "trader-name-and-last-login";
